function consultationScheWA(payload) {
    var WA = `Estimado/a ${payload.patient_name}:\nSu cita se agendó éxitosamente \n\n Fecha: ${payload.date_time}\n Hora: ${payload.hour} \n Doctor: ${payload.doctor_name}\n Consulta ID: ${payload.event_id} \n Para su comodidad y su seguridad llena el *formulario obligatorio*\n`

    return WA
}

export {consultationScheWA}